import * as React from 'react';

const HashtagSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="hashtag_svg__eds-icon--hashtag_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="hashtag_svg__eds-icon--hashtag_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M6.7 20h1.1l1.1-4.8h4.9L12.6 20h1.1l1.1-4.8H18v-.9h-3l1-4.5h3v-1h-2.8L17.3 4h-1.1l-1.1 4.8h-4.9L11.4 4h-1.1L9.2 8.8H6v.9h3l-1 4.5H5v.9h2.8L6.7 20zM9 14.2l1-4.5h5l-1 4.5H9z"
        />
    </svg>
);

HashtagSvg.displayName = 'HashtagSvg';
export default HashtagSvg;
